module.exports = __webpack_public_path__ + "static/media/rollerTech.4ad3b0b4.png";